import { CompanyApplication } from 'apis/CompanyAPI/communities/applications/communityApplicationsApi';
import useSWR from 'hooks/useSWR';
import { useSWRResource } from 'util/resource/useSWRResource';
import { applicationUrls } from 'apis/CompanyAPI/communities/applications/communityApplicationsApi';

export const companyApplicationAnswersKey = (communityId: number, companyId: number) =>
  applicationUrls.listAnswersForCompany(communityId, companyId);

export const useCompanyApplicationAnswers = (communityId: number | undefined, companyId: number | undefined) => {
  const swrResult = useSWR<CompanyApplication>(
    communityId && companyId ? companyApplicationAnswersKey(communityId, companyId) : undefined,
  );

  return useSWRResource(swrResult);
};

export const companyApplicationKey = (communityId: number, companyId: number) =>
  applicationUrls.getForCompany(communityId, companyId);

export const useCompanyApplication = (communityId: number | undefined, companyId: number | undefined) => {
  const swrResult = useSWR<CompanyApplication>(
    communityId && companyId ? companyApplicationKey(communityId, companyId) : undefined,
  );

  return useSWRResource(swrResult);
};
